import { VariableType } from 'json-to-graphql-query';

export const OptionValueByCodeVariables = { code: 'String!', entityType: 'String!', entityId: 'String!' };
export const OptionValueByCodeParams = {
  code: new VariableType('code'),
  entityType: new VariableType('entityType'),
  entityId: new VariableType('entityId')
};
